export default "__VITE_ASSET__nj4TxV5C__"